module.exports = __webpack_public_path__ + "img/friendVip.b6265658.png";